<template>
  <div :style="styles.base">
    <div v-for="(item,index) in configList" :key="index" :style="chooseDiv">
      <img v-if="choosePkg === item.packageId" :style="chooseImg" :src="item.imgGray" alt=""
           @click="choose(item,index)">
      <img v-else :style="chooseImg" :src="item.img" alt="" @click="choose(item,index)">
    </div>
    <c-button @click="handleClickEvent()" ref="button"
              :class='getCss("btn-class")'
              :style="computeouterStyle"
              v-bind="$props"></c-button>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin } from '@tencent/ceiba-base-components';

export default {
  name: 'CTgclubChooseOne',
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'tgclub-choose-one-',
      choosePackageId: '',
      chooseOk: false,
      choosePkg: '',
      receiveStatus: 'reward',
    };
  },
  computed: {
    backgroundImageMap() {
      return {
        reward: this.configurationData.backgroundReceiveBright || 'https://game.gtimg.cn/images/tgclub/act/a20220117test/03.png',
        rewarded: this.configurationData.backgroundReceiveGrey || 'https://game.gtimg.cn/images/tgclub/act/a20220117test/031.png',
      };
    },
    computeouterStyle() {
      return {
        backgroundImage: `url(${this.backgroundImageMap[this.receiveStatus]})`,
        width: '150px',
        height: '50px',
        position: 'absolute',
        left: 0,
        top: '2rem',
        right: 0,
        bottom: 0,
        margin: 'auto',
      };
    },
    chooseDiv() {
      const widthNum = this.styles.base.width;
      const heightNum = this.styles.base.height;
      if (this.isPC()) {
        return {
          margin: '0px 10px',
          width: '200px',
          height: '200px',
          float: 'left',
        };
      }
      console.log('parseInt(this.styles.base.width, 10)', this.styles.base.width);
      return {
        margin: `0rem ${this.configList.length * 0.2 / 6}rem`,
        width: `${(parseFloat(widthNum.substring(0, widthNum.length - 3)) - this.configList.length * 0.2) / this.configList.length}rem`,
        height: `${(parseFloat(heightNum.substring(0, heightNum.length - 3))) / 2}rem`,
        float: 'left',
      };
    },
    chooseImg() {
      return {
        width: '100%',
        height: '100%',
      };
    },
    configList() {
      return this.configurationData.configList || [];
    },
    successMsg() {
      return this.configurationData.msg || '选择完成！';
    },
  },
  async mounted() {
    console.log('configurationData=', this.configurationData);
    await this.initialize();
  },
  methods: {
    async initialize() {
      this.$refs.button.setClickHandler(this.doReward, {
        forceApp: this.configurationData.forceApp,
        forceLogin: true,
        forceRole: this.actInfo.extendConfig.forceRole,
      });
      // 查询是否已选择
      try {
        const response = await this.flowRequest({
          flowId: this.configurationData.queryFlowId,
          params: {
            role: this.roleInfo,
          },
        });
        console.log('CTgclubChooseOne and check ret  response=  ', response);
        const { ret, packageId } = response.data;
        if (ret === 0 && packageId > 0) {
          this.chooseOk = true;
          this.choosePkg = packageId;
          this.receiveStatus = 'rewarded';
        }
      } catch (e) {
        console.log('CTgclubChooseOne fail,er=', e);
      }
    },
    choose(item) {
      if (this.chooseOk) {
        return;
      }
      console.log(item);
      this.choosePkg = item.packageId;
      this.choosePackageId = item.packageId;
    },
    async doReward() {
      if (this.receiveStatus === 'rewarded') {
        return;
      }
      if (!this.choosePackageId) {
        this.alert('请先选择再来确认哦');
        return;
      }
      const response = await this.flowRequest({
        flowId: this.configurationData.reqFlowId,
        params: {
          role: this.roleInfo,
          data: JSON.stringify({ packageId: `${this.choosePackageId}` }),
        },
      });
      console.log('response-coupons', response);
      if (response.data.ret) {
        this.alert(response.data.msg || response.msg);
        this.reportClickRaw({
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: 'submit',
          eventData: {
            gift_id: this.choosePackageId || '',
            status: '0',
          },
        });
        return;
      }
      this.chooseOk = true;
      this.choosePkg = this.choosePackageId;
      this.receiveStatus = 'rewarded';
      alert(this.successMsg);
      this.reportClickRaw({
        ceibaComponentId: `${this.cid}`,
        ceibaComponentUid: this.uid,
        ceibaComponentUname: this.uname,
        eventKey: 'submit',
        eventData: {
          gift_id: this.choosePackageId || '',
          status: '1',
        },
      });
    },
    isPC() {
      const u = navigator.userAgent;
      const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; // 判断是否是 android终端
      const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // 判断是否是 iOS终端
      if (isAndroid) {
        return false;
      }
      if (isIOS) {
        return false;
      }
      return true;
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
